import { FETCH_CONTENT_IMPRESSION_STATS, LOAD_CONTENT_IMPRESSION_STATS } from '../Actions/ContentImpression'

const initialState = {
  loading: false,
  data: []
}

/**
 * ContentImpressionReducer
 * @desc Reducer for handling content-specific impression stats state
 * @param {Object} state current state
 * @param {Object} action dispatched action
 * @return {Object} updated state
 */
export default function ContentImpressionReducer (state = initialState, action) {
  switch (action.type) {
    case FETCH_CONTENT_IMPRESSION_STATS:
      return { ...state, loading: true }
    case LOAD_CONTENT_IMPRESSION_STATS:
      return { ...state, loading: false, data: action.data }
    default:
      return state
  }
}
